export interface HumanOfHeard {
  name: string
  photo: string
  value: string
  blurb: string
}

export const HUMANS_OF_HEARD = {
  title: 'Humans of Heard',
  subtitle: 'Living our Values',
  label: 'All Hands · October 2026',
  winners: [
    {
      name: 'Leah Judge',
      photo: 'https://heard-images.s3.amazonaws.com/assets/ownit-1.png',
      value: 'Own It Together',
      blurb:
        'Exceptional project delivery, innovation and creative problem solving',
    },
    {
      name: 'Autumn Eldridge',
      photo: 'https://heard-images.s3.amazonaws.com/assets/human-led-1.png',
      value: 'Human-Led, AI-Powered',
      blurb:
        'Process improvements and efficiency, AI as a force multiplier, exceptional results',
    },
    {
      name: 'Udesh Rodrigo',
      photo: 'https://heard-images.s3.amazonaws.com/assets/ownit-2.png',
      value: 'Own It Together',
      blurb:
        'Outstanding collaboration, mentoring and developing others, AI as a force multiplier',
    },
    {
      name: 'Jared Franco',
      photo: 'https://heard-images.s3.amazonaws.com/assets/human-led-2.png',
      value: 'Human-Led, AI-Powered',
      blurb: 'Customer impact and satisfaction, AI as a force multiplier',
    },
  ] satisfies HumanOfHeard[],
}
